import React from 'react';
import PropTypes from 'prop-types';
import styles from './guides.module.scss';

const Guide = ({imgSrc, imgAlt, heading, href, text}) => (
  <a className={styles.Guide} href={href} target="_blank">
    <img alt={imgAlt} className={styles.Guide__img} src={imgSrc} />
    <div className={styles.Guide__content}>
      <p className={styles.Guide__label}>Guide</p>
      <h3 className={styles.Guide__heading}>{heading}</h3>
      <p className={styles.Guide__text}>{text}</p>
      <span className={styles.Guide__cta}>
        Read the guide <span aria-hidden="true">&rarr;</span>
      </span>
    </div>
  </a>
);

Guide.propTypes = {
  heading: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  imgAlt: PropTypes.string,
  imgSrc: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

Guide.defaultProps = {
  imgAlt: '',
};

export default Guide;



// WEBPACK FOOTER //
// ./src/components/guides/Guide.js